import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import { BModal, BvModalEvent } from 'bootstrap-vue'
import { Spinner } from '@kwixeo/interface-vue'

@Component({
  components: {
    BModal,
    Spinner
  },
  methods: {
    ...mapActions('dashboard', ['deleteDashboard'])
  }
})
export default class DashboardDelete extends Vue {
  deleteDashboard!: (dashboard: KwixeoDashboard.Dashboard) => void

  @Prop({ required: true }) value!: KwixeoDashboard.Dashboard
  @Prop({ default: false }) modal!: boolean

  private loading = false
  private modalState = false

  @Watch('modal', { immediate: true })
  private watchModal (state: boolean): void {
    this.modalState = state
  }

  private async process (event: BvModalEvent): Promise<void> {
    event.preventDefault()
    this.loading = true
    await this.$kwDashboard.axios.delete('/dashboard/' + this.value?.id)
      .then(() => {
        this.deleted()
        this.closeModal()
      })
      .catch(error => {
        throw new Error(error)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private closeModal (): void {
    this.$emit('closed')
  }

  private canceled (): void {
    this.$emit('canceled')
  }

  private deleted (): void {
    this.deleteDashboard(this.value)
    this.$emit('deleted')
  }
}
